module.exports = __webpack_public_path__ + "static/media/fff_join_mouseOn.9c3b6e14.gif";